import React from 'react';
import { InputLabelLayoutProps, useFormContext } from 'ui-builder';
import { cn, Label } from 'shadcn-ui';

export default function ShadcnInputLabelLayout(props: InputLabelLayoutProps) {
  const formContext = useFormContext();

  const showRequiredIcon = props.showRequiredIcon !== undefined ? props.showRequiredIcon : true;

  if (!props.hideLabel) {
    return (
      <Label
        className={cn(props.bold && 'font-bold', 'mb-0', props.className)}
        data-testid={props.testID}
      >
        {props.label}
        {props.afterLabelElement}
        {showRequiredIcon
          && formContext.isFieldRequired
          && formContext.isFieldRequired(props.name)
          && (<span className="text-rose-600">*</span>)}
      </Label>
    );
  } else {
    return null;
  }
}
